import { useState, useEffect } from 'react';
import { UserCircle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { DependentDto } from 'enrollment/queries/useBenefitCategoryQuery/types';
import {
  useEnrollmentProfileQuery,
  useEnrollmentFamilyQuery,
} from 'enrollment/queries';
import { displayDependentAvatar } from 'enrollment/features/Family/FamilyDetailsPage/components';
import { TooltipWrapper } from 'enrollment/components/Shared/TooltipWrapper';
import { DrawerDialog } from 'enrollment/components/DrawerDialog';

interface CoveredProps {
  individuals?: DependentDto[];
  isDeclinePlan?: boolean;
  isDependentOnlyPlan: boolean;
  benefitCategory: string;
}

export const Covered: React.FC<CoveredProps> = ({
  individuals = [],
  isDeclinePlan,
  isDependentOnlyPlan,
  benefitCategory,
}) => {
  const { t } = useTranslation('pages.enrollment.review');
  const { subscriber } = useEnrollmentProfileQuery({ lumosEnabled: true });
  const subscriberProfile = subscriber?.data?.subscriber_profile;
  const { dependentsData } = useEnrollmentFamilyQuery({ lumosEnabled: true });
  const dependentProfiles = dependentsData?.data?.dependents;

  const showUserAvatar =
    !isDeclinePlan &&
    !isDependentOnlyPlan &&
    benefitCategory !== 'contribution';

  // Begin Copilot
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [showLength, setShowLength] = useState(3);

  useEffect(() => {
    if (window.innerWidth < 993) {
      setShowLength(1);
    } else {
      setShowLength(3);
    }
  }, []);

  const handleLinkClick = (event: React.MouseEvent) => {
    event.preventDefault();
    setDrawerOpen(true);
  };
  // end Copilot
  return (
    <>
      <div
        className="covered-individuals"
        aria-label={t('covered')}
        role="group"
      >
        {showUserAvatar && (
          <div className="covered" data-testid="youAvatar">
            {subscriberProfile ? (
              displayDependentAvatar(subscriberProfile, 24)
            ) : (
              <UserCircle />
            )}
            &nbsp;{t('you')}
          </div>
        )}
        {individuals.slice(0, showLength).map(
          (
            individual,
            index // Copilot suggestion
          ) => (
            <div key={index} className="covered">
              {displayDependentAvatar(
                dependentProfiles?.find(
                  (profile) => profile.id === individual?.dependent_id
                )?.dependent_profile,
                24
              ) || <UserCircle />}

              {individual.dependent_name.split(' ')[0].length > 10 ? (
                <TooltipWrapper
                  position="top"
                  tooltipContent={individual.dependent_name.split(' ')[0]}
                >
                  <button className="truncate body2">
                    &nbsp;{individual.dependent_name.split(' ')[0]}
                  </button>
                </TooltipWrapper>
              ) : (
                <span className="body2">
                  &nbsp;{individual.dependent_name.split(' ')[0]}
                </span>
              )}
            </div>
          )
        )}
        {/* Begin Copilot */}
        {individuals.length > showLength && (
          <div className="covered">
            <button onClick={handleLinkClick} className="faux-link body2">
              +{individuals.length - showLength} {t('drawer.more')}
            </button>
          </div>
        )}
      </div>
      <DrawerDialog
        openDialog={isDrawerOpen}
        closeDialog={() => setDrawerOpen(false)}
        dialogHeading={t('drawer.title')}
        showOnlyCloseButton={true}
      >
        <>
          {showUserAvatar && (
            <div>
              <div className="covered mb-3">
                {subscriberProfile ? (
                  displayDependentAvatar(subscriberProfile, 24)
                ) : (
                  <UserCircle />
                )}
                <span className="body2 ml-2">{t('you')}</span>
              </div>
            </div>
          )}
          {individuals.map((individual, index) => (
            <div key={index}>
              <div className="covered mb-3">
                {displayDependentAvatar(
                  dependentProfiles?.find(
                    (profile) => profile.id === individual?.dependent_id
                  )?.dependent_profile,
                  24
                )}
                <span className="body2 ml-2">
                  {individual.dependent_name.split(' ')[0]}
                </span>
              </div>
            </div>
          ))}
        </>
      </DrawerDialog>
      {/* End Copilot */}
    </>
  );
};
